import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { storageKey } from './storageKeys';

import type { AuthMember } from '@/types/auth';
import type { AuthSession } from '@/types/auth';
export type { AuthMember } from '@/types/auth';

interface AuthState {
  accessToken?: string;
  refreshToken?: string;
  member?: AuthMember;
  /** Runtime-only identity fence; rotating a refresh token keeps this session. */
  sessionEpoch: number;
  saveSession: (session: AuthSession) => void;
  saveTokens: (tokens: { accessToken: string; refreshToken: string }) => void;
  saveMember: (member: AuthMember) => void;
  clear: () => void;
}

const initialData = {
  accessToken: undefined,
  refreshToken: undefined,
  member: undefined,
};

/** 회원 토큰 (Member Access 30분 + 불투명 Refresh, 실행계획 3.5). */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      ...initialData,
      sessionEpoch: 0,
      saveSession: ({ accessToken, refreshToken, member }) =>
        set((state) => ({
          accessToken,
          refreshToken,
          member,
          sessionEpoch: state.sessionEpoch + 1,
        })),
      saveTokens: ({ accessToken, refreshToken }) =>
        set({ accessToken, refreshToken }),
      saveMember: (member) =>
        set((state) => ({
          member,
          sessionEpoch:
            state.sessionEpoch + (state.member?.id === member.id ? 0 : 1),
        })),
      clear: () =>
        set((state) => ({
          ...initialData,
          sessionEpoch: state.sessionEpoch + 1,
        })),
    }),
    {
      name: storageKey.AUTH_STORE,
      partialize: ({ accessToken, refreshToken, member }) => ({
        accessToken,
        refreshToken,
        member,
      }),
    },
  ),
);

export const selectIsMember = (state: AuthState) => Boolean(state.accessToken);
